import React, { useRef } from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { useNavigate } from "react-router-dom";
// import clientPhoto from '../NYCLogo/NYC-logo-header.png';

const ThankYou = ({ formData }) => {
  const componentRef = useRef();
  const hiddenRef = useRef();
  const navigate = useNavigate();

  const handleDownload = async () => {
    const input = hiddenRef.current;
    const canvas = await html2canvas(input, {
      scale: 2,
      useCORS: true,
    });
    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF();
    pdf.addImage(imgData, "PNG", 0, 0);
    pdf.save("NYC_Application_Submission_Details.pdf");
  };

  const handleRefersh = () => {
    localStorage.setItem("validWithOTP", true);
    localStorage.setItem("validSalesPerson", false);
    localStorage.setItem("validNewCustomer", false);
    setTimeout(() => {
      navigate("/home/inventory");
      window.location.reload();
    }, 3000);
  };

  return (
    <div className="thank-you" ref={componentRef}>
      <div className="headerImage">
        {/* <img src={clientPhoto} alt="NYC Logo" className="client-photo" /> */}
      </div>
      <h2>Thank You!</h2>
      <p>Your order has been submitted successfully.</p>
      <div className="flex flex-col">
        <span
          className="text-blue-500 hover:cursor-pointer hover:underline text-md font-semibold"
          onClick={handleRefersh}
        >
          Return to explore our products
        </span>

        {/* <div
          className="hidden-for-pdf"
          ref={hiddenRef}
          style={{ display: "block", position: "absolute", top: "-9999px" }}
        >
          <h3>Contact Information</h3>
          <p>
            Name: {formData.contactFirstName} {formData.contactLastName}
          </p>
          <p>Email: {formData.email}</p>
          <p>Phone: {formData.phoneNumber}</p>
          <p>Where did you hear about us: {formData.hearAboutUs}</p>
          <p>Company Name: {formData.companyName}</p>

          <h3>Company Information</h3>
          <p>Sales Rep who reached out to you: {formData.salesRep}</p>
          <p>Customer Type: {formData.customerType.join(", ")}</p>
          <p>Business Category: {formData.businessCategory.join(", ")}</p>

          <h3>Shipping Address Details</h3>
          <p>Address Line 1: {formData.shippingAddressLine1}</p>
          <p>Address Line 2: {formData.shippingAddressLine2}</p>
          <p>Country: {formData.shippingCountry}</p>
          <p>State: {formData.shippingState}</p>
          <p>City: {formData.shippingCity}</p>
          <p>Zip Code: {formData.shippingZipCode}</p>

          <h3>Billing Address Details</h3>
          <p>Street Address: {formData.billingStreetAddress}</p>
          <p>Suite: {formData.billingSuite}</p>
          <p>Country: {formData.billingCountry}</p>
          <p>State: {formData.billingState}</p>
          <p>City: {formData.billingCity}</p>
          <p>Zip Code: {formData.billingZipCode}</p>

          <h3>Terms of Sales</h3>
          <p>Terms Accepted: {formData.termsAccepted ? "Yes" : "No"}</p>
          <p>Job Title: {formData.jobTitle}</p>
          <p>Date: {formData.date}</p>
        </div> */}
      </div>
{/* 
      <button onClick={handleDownload} className="download-button">
        Download PDF
      </button> */}
    </div>
  );
};

export default ThankYou;
